import { FC, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { RouteComponentProps } from "react-router";

import { ChangesNotSavedModal } from "components/modals/ChangesNotSavedModal";
import { AutomationsRoutes, WORKFLOW_CHANGES_NOT_SAVED_MODAL_DESC } from "routes/automations/constants";
import { selectRules } from "store/entities/rules/selectors";

import WorkflowsViewContainer from "../components/FullPageViewContainer";
import RuleEditor from "../components/editor";
import { StyledContentWrapper } from "../components/styled";
import { PageWrapper } from "../styled";

const EditWorkflow: FC<RouteComponentProps<{ id: string }>> = ({ match, history }) => {
  const rules = useSelector(selectRules);
  const editedRule = useMemo(() => rules.find(rule => rule.id === match.params.id), [match.params.id, rules]);

  const [formPristine, setFormPristine] = useState(true);
  const [changesNotSavedModalOpen, setChangesNotSavedModalOpen] = useState(false);

  const handleBackToList = (): void => {
    if (formPristine) {
      history.push(AutomationsRoutes.Rules);
    } else {
      setChangesNotSavedModalOpen(true);
    }
  };

  const handleDiscardChanges = (): void => {
    history.push(AutomationsRoutes.Rules);
  };

  const handleBackToEditing = (): void => {
    setChangesNotSavedModalOpen(false);
  };

  useEffect(() => {
    if (!editedRule) {
      history.push(AutomationsRoutes.Rules);
    }
  }, [editedRule, history, match]);

  return editedRule ? (
    <WorkflowsViewContainer title="Edit rule" onBack={handleBackToList}>
      <PageWrapper>
        <StyledContentWrapper>
          <RuleEditor
            rule={editedRule}
            fromTemplate={null}
            setFormPristine={setFormPristine}
            handleBackToList={handleBackToList}
          />
          <ChangesNotSavedModal
            isOpen={changesNotSavedModalOpen}
            onDiscardChanges={handleDiscardChanges}
            onBackToEditing={handleBackToEditing}
          >
            {WORKFLOW_CHANGES_NOT_SAVED_MODAL_DESC}
          </ChangesNotSavedModal>
        </StyledContentWrapper>
      </PageWrapper>
    </WorkflowsViewContainer>
  ) : null;
};

export default EditWorkflow;
